<template>
  <qc-dialog class="tc-15-rich-dialog cos" type="custom" :show="innerShow" :title="'导入'" :default-cancel="false"
    @close="closeDialog" :width="550" :closeTriggers="['esc']">

    <qc-step :active="stepIndex">
      <qc-step-item>选择导入内容</qc-step-item>
      <qc-step-item>开启静态网站</qc-step-item>
    </qc-step>

    <ul class="form-list form-list-vertical" v-if="stepIndex === 0">
      <li>
        <div class="form-label ">
          <label>导入类型</label>
        </div>
        <div class="form-input">
          <div class="form-unit">
            <qc-radio-group v-model="type" @input="onChangeType">
              <qc-radio value="local" title="本地压缩包">本地压缩包</qc-radio>
              <qc-radio value="remote" title="远端压缩包">远端压缩包</qc-radio>
              <qc-radio value="github" title="Github 仓库">Github 仓库</qc-radio>
              <qc-radio value="template" title="静态网站模板">静态网站模板</qc-radio>
            </qc-radio-group>
          </div>
        </div>
      </li>

      <li v-if="type === 'local'">
        <div class="form-label ">
          <label>
            本地文件
          </label>
        </div>
        <div class="form-input">
          <div class="form-unit">
            <qc-input class="width-400" v-model="editAddress" readonly :title="editAddress"></qc-input>
            <!-- <qc-button type="link">选择</qc-button> -->
            <qc-file-select accept=".zip" v-model="selectFile" @input="onFileSelect">
              <qc-button type="link">选择</qc-button>
            </qc-file-select>
            <div class="form-input-help">仅支持导入大小不超过 50MB 后缀为 .zip 的压缩包文件</div>
          </div>
        </div>
      </li>
      <li v-else-if="type === 'remote'">
        <div class="form-label ">
          <label>
            远端地址
          </label>
        </div>
        <div class="form-input">
          <div class="form-unit">
            <qc-input class="width-400" v-model.trim="editAddress"></qc-input>
            <div class="form-input-help">仅支持导入大小不超过 50MB 后缀为 .zip 的压缩包文件</div>
          </div>
        </div>
      </li>
      <li v-else-if="type === 'github'">
        <div class="form-label ">
          <label>
            仓库地址
          </label>
        </div>
        <div class="form-input">
          <div class="form-unit">
            <qc-input class="width-400" v-model.trim="editAddress"
              placeholder="https://github.com/organization/repository.git">
            </qc-input>
            <div class="form-input-help">仅支持导入大小不超过 50MB 的 GitHub 仓库</div>
          </div>
        </div>
      </li>
      <li v-else-if="type === 'template'">
        <div class="form-label ">
          <label>
            选择模板
          </label>
        </div>
        <div class="form-input">
          <div class="form-unit mb-25">
            <qc-select class="custom-select-template width-400" type="button" :minWidth="400" v-model="templateValue"
              @change="handleAddress">
              <qc-option value="docsify">docsify 静态博客</qc-option>
            </qc-select>
          </div>
        </div>
      </li>
    </ul>

    <template v-else>
      <div class="param-bd" v-if="loadingWebsite">
        <p class="text-center" style="margin: 20px 0">
          <qc-icon type="loading"></qc-icon> {{$t('core.loading')}}
        </p>
      </div>
      <div class="param-bd" v-else-if="!hasAuth || errorMsg">
        <p class="text-center" style="margin: 20px 0"> {{errorMsg}} </p>
      </div>
      <template v-else>
        <qc-alert>
          注意：当前只对静态网站简单配置，可在菜单项【静态网站配置】进行详细配置。
        </qc-alert>
        <ul class="form-list form-list-vertical allow-user-select">
          <li class="pure-text-row">
            <div class="form-label"><label>访问结点</label></div>
            <div class="form-input">
              <div class="form-unit">
                <p class="form-text">{{websiteInfo.accessUrl}}</p>
              </div>
            </div>
          </li>

          <li>
            <div class="form-label"><label>索引文档</label></div>
            <div class="form-input">
              <div class="form-unit" :class="{'is-error': suffixError.isError}">
                <qc-input v-model="websiteInfo.IndexDocument.Suffix" placeholder="例如：index.html"
                  @input="suffixValidate">
                </qc-input>
                <p class="form-input-help">{{suffixError.msg}}</p>
              </div>
            </div>
          </li>
        </ul>
      </template>

    </template>

    <div slot="button">
      <div class="justify-grid">
        <div class="col"></div>
        <div class="col">
          <qc-button type="default" @click="onChangeStep" :title="$t('core.step['+ stepIndex +']')">
            {{$t('core.step['+ stepIndex +']')}}</qc-button>
          <qc-button type="weak" :disabled="disableBtnProxy" @click="onSubmit">{{$t('core.ok')}}</qc-button>
        </div>
      </div>
    </div>

  </qc-dialog>
</template>

<script>
import COS from '@/plugins/cos_sdk/src/cos';
import { getInnerProps, path, tips } from '@/scripts/tools/utils';
import eventProxy from '@/scripts/tools/eventProxy';
import dao from '@/scripts/helper/dao';
import cos from '@/scripts/helper/cos';

const templateMap = {
  docsify:
    'https://cosbrowser-1253960454.file.myqcloud.com/web/docsify.zip',
};
const MB = 1 * 1024 * 1024;

export default {
  props: {
    show: {
      type: Boolean,
      required: true,
      default: false,
    },
    bucketInfo: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      editAddress: '', // 编辑路径
      realAddress: '', // 真实路径
      selectFile: null, // 本地文件
      type: 'local',
      templateValue: 'docsify',
      stepIndex: 0,

      hasAuth: true,
      errorMsg: '',
      websiteInfo: {},
      oldSuffix: '',
      loadingWebsite: false,
      suffixError: {
        isError: false,
        msg: '',
      },
    };
  },
  computed: {
    innerShow: getInnerProps('show'),
    bucketInfoProxy: getInnerProps('bucketInfo'),
    disableBtnProxy() {
      return !this.editAddress && !this.realAddress;
    },
  },
  watch: {
    show(val) {
      if (val) {
        this.initData();
        this.getWebsiteInfo();
      }
    },
  },
  methods: {
    initData() {
      this.editAddress = ''; // 编辑路径
      this.realAddress = ''; // 真实路径
      this.type = 'local';
      this.templateValue = 'docsify';
      this.stepIndex = 0;
      this.hasAuth = true;
      this.errorMsg = '';
      this.websiteInfo = {};
      this.loadingWebsite = false;
      this.suffixError = {
        isError: false,
        msg: '',
      };
    },
    onChangeStep() {
      const check = val => (val === 1 ? 0 : 1);
      this.stepIndex = check(this.stepIndex);
    },
    onChangeType(type) {
      this.editAddress = '';
      this.realAddress = '';
      if (type === 'template') {
        this.handleAddress();
      }
    },
    onFileSelect(file) {
      const size = this.selectFile.size / MB;
      if (size > 50) {
        tips.error('上传的文件大小超过 50M');
      } else {
        this.editAddress = file.name;
      }
    },
    suffixValidate(val) {
      let isError = true;
      let msg = '访问目录时匹配的索引文档';
      if (!val.trim()) {
        msg = '索引文档不能为空';
      } else if (val.includes('?')) {
        msg = '索引文档不能包含斜线和问号';
      } else if (val.indexOf('/') === 0) {
        msg = '请勿以 / 开头';
      } else {
        isError = false;
      }
      this.suffixError = {
        isError,
        msg,
      };
    },
    localAddressValidate(address) {
      const extname = path.extname(address);
      const allowImportExt = ['.zip'];
      if (!allowImportExt.includes(extname)) {
        return '只支持导入 .zip 后缀';
      }
      return '';
    },
    remoteUrlValidate(url) {
      const checkUrl = /http(s)?:\/\/([\w-]+\.)+[\w-]+(\/[\w- .\/?%&=]*)?/;
      if (!checkUrl.test(url)) {
        return this.$t('error.invalid_url');
      }
      let domain = url;
      if (domain.indexOf('?') !== -1) {
        [domain] = domain.split('?');
      }
      return this.localAddressValidate(domain);
    },
    githubValidate(url) {
      const checkUrl = /http(s)?:\/\/github\.com(\/[\d\w.-]+?){2}\.git$/;
      if (!checkUrl.test(url)) {
        return '请输入正确的 Github 仓库链接';
      }
      return '';
    },
    async transformLocalFileToUrl() {
      // eslint-disable-next-line
      let sid, skey, token, filename;
      try {
        const data = await dao.getStsWhileImport(this.editAddress);
        [sid, skey, token, filename] = [
          data.sid,
          data.skey,
          data.token,
          data.filename,
        ];
      } catch (err) {
        return { error: err };
      }
      try {
        const localCos = new COS({
          SecretId: sid,
          SecretKey: skey,
          SecurityToken: token,
          UploadCheckContentMd5: true,
        });
        const opt = {
          Bucket: 'cosbrowser-import-1253960454',
          Region: 'ap-guangzhou',
          Key: filename,
        };
        await localCos.sliceUploadFile({
          ...opt,
          Body: this.selectFile,
        });
        const address = localCos.getObjectUrl({
          ...opt,
          Sign: true,
          Expires: 3600,
        });
        return { address };
      } catch (error) {
        return { error };
      }
    },
    async handleAddress() {
      let errMsg;
      const { editAddress } = this;
      switch (this.type) {
        case 'local': {
          const { address, error } = await this.transformLocalFileToUrl();
          if (error) {
            errMsg = window.lang.err(`error['${error.code}']`, error);
          } else {
            this.realAddress = address;
          }
          break;
        }
        case 'remote': {
          errMsg = this.remoteUrlValidate(editAddress);
          this.realAddress = editAddress;
          break;
        }
        case 'github': {
          errMsg = this.githubValidate(editAddress);
          // 去除 .git 后缀变为 zip 链接
          this.realAddress = `${editAddress.slice(0, -4)}/archive/master.zip`;
          break;
        }
        case 'template': {
          errMsg = '';
          this.realAddress = templateMap[this.templateValue];
          break;
        }
        default: {
          break;
        }
      }
      if (errMsg) {
        tips.closeTips();
        tips.error(errMsg);
        throw new Error(errMsg);
      }
    },
    async getStsParams() {
      // eslint-disable-next-line
      let sid, skey, token;
      const { Bucket, Region } = this.bucketInfo;
      const AppId = Bucket.substr(Bucket.lastIndexOf('-') + 1);
      try {
        const Policy = {
          version: '2.0',
          statement: [
            {
              action: [
                // 简单上传
                'name/cos:PutObject',
                // 分片上传
                'name/cos:InitiateMultipartUpload',
                'name/cos:ListMultipartUploads',
                'name/cos:ListParts',
                'name/cos:UploadPart',
                'name/cos:CompleteMultipartUpload',
                'name/cos:UploadPartCopy',
                'name/cos:AbortMultipartUpload',
              ],
              effect: 'allow',
              resource: [`qcs::cos:${Region}:uid/${AppId}:${Bucket}/*`],
            },
          ],
        };
        const stsData = await dao.getSts({
          Region,
          DurationSeconds: 7200,
          Policy: JSON.stringify(Policy),
        });

        const { Credentials } = stsData;
        const { TmpSecretId, TmpSecretKey, Token } = Credentials;
        [sid, skey, token] = [TmpSecretId, TmpSecretKey, Token];
        return { sid, skey, token };
      } catch (err) {
        if (err) {
          let code = err.code || err;
          if (this.$store.userInfo.AppId !== AppId) {
            code = 'curr_bucket_not_belongs_to_you';
          }
          const msg = this.$t(`error['${code}']`)
            || window.lang.err(`error['${code}']`, err);
          tips.error(msg);
        }
        tips.closeTips();
        return null;
      }
    },
    getWebsiteInfo() {
      this.loadingWebsite = true;
      const { bucketInfo } = this;
      const { Bucket, Region } = bucketInfo;
      cos.getBucketWebsite(bucketInfo, (err, data) => {
        let Website = `${Bucket}.cos-website.${Region}.myqcloud.com`;
        if (err || data.statusCode === 404) {
          Website = '';
        }

        if (Website !== bucketInfo.Website) {
          this.bucketInfoProxy = { ...bucketInfo, Website };
        }

        if (err) {
          const { error } = err;
          if (error && error.Code === 'AccessDenied') {
            this.errorMsg = this.$t(
              'error.no_permissions_to_get_bucket_website',
            );
            this.hasAuth = false;
          } else {
            this.errorMsg = '获取静态网站信息失败';
          }
          this.websiteInfo = {
            openWebsite: false,
            accessUrl: `https://${Bucket}.cos-website.${Region}.myqcloud.com`,
            IndexDocument: {
              Suffix: 'index.html',
            },
          };
        } else {
          const { WebsiteConfiguration } = data;
          this.websiteInfo = {
            openWebsite: Object.keys(WebsiteConfiguration).length > 0,
            accessUrl: `https://${Bucket}.cos-website.${Region}.myqcloud.com`,
            IndexDocument: WebsiteConfiguration.IndexDocument || {
              Suffix: 'index.html',
            },
          };
          const {
            ErrorDocument,
            RedirectAllRequestsTo,
            RoutingRules,
          } = WebsiteConfiguration;
          if (ErrorDocument) {
            this.websiteInfo.ErrorDocument = ErrorDocument;
          }
          if (RedirectAllRequestsTo) {
            this.websiteInfo.RedirectAllRequestsTo = RedirectAllRequestsTo;
          }
          if (RoutingRules) {
            this.websiteInfo.RoutingRules = RoutingRules;
          }
          this.oldSuffix = this.websiteInfo.IndexDocument.Suffix;
        }

        this.loadingWebsite = false;
      });
    },
    async onSubmit() {
      tips.loading('正在导入中，请勿刷新或关闭页面...');
      try {
        await this.handleAddress();
      } catch (error) {
        return;
      }

      const stsParams = await this.getStsParams();
      if (!stsParams) return;

      let successList;
      let errorList;
      try {
        const importRes = await dao.importProject({
          ...this.bucketInfo,
          ...stsParams,
          url: this.realAddress,
        });
        tips.closeTips();
        [successList, errorList] = [importRes.successList, importRes.errorList];
      } catch (err) {
        // 导入失败，则不进行之后的操作
        tips.closeTips();
        const { code } = err;
        if (this.type === 'github' && code === 'Downloader.UrlNotFound') {
          tips.error('Github 仓库不存在或是私有仓库，无法导入');
        } else {
          tips.error(this.$t(`error['${err.code}']`));
        }
        return;
      }

      const finalHandle = err => {
        this.showResult(errorList, successList, err);
        setTimeout(() => {
          eventProxy.emit('command.refresh');
        }, 2000);
      };

      try {
        if (this.websiteInfo.openWebsite) {
          finalHandle();
          return;
        }
        const WebsiteConfiguration = {};
        Object.keys(this.websiteInfo).forEach(key => {
          if (['openWebsite', 'accessUrl'].includes(key)) return;
          WebsiteConfiguration[key] = this.websiteInfo[key];
        });
        await cos.putBucketWebsite({
          ...this.bucketInfo,
          WebsiteConfiguration,
        });
        finalHandle();
      } catch (error) {
        tips.closeTips();
        finalHandle(error);
      }
    },
    showResult(errorList, successList, error) {
      this.closeDialog();
      const messages = [];
      let type = 'success';
      if (errorList && successList) {
        if (errorList.length > 0) {
          eventProxy.emit('failureTable.show', {
            type: 'import',
            failedList: errorList,
          });
        } else {
          messages.push('资源导入成功');
        }
      }
      // 展示静态网站配置结果
      if (error) {
        const { code } = error;
        type = 'error';
        if (code === 'AccessDenied') {
          messages.push(this.$t('error.no_permissions_to_put_bucket_website'));
        } else {
          messages.push(`开启静态网站失败：${window.lang.err(`error['${code}']`, error)}`);
        }
      } else {
        messages.push('静态网站已开启');
      }

      if (messages.length > 0) {
        tips.notification({ message: messages.join(','), type });
      }
    },
    closeDialog() {
      this.innerShow = false;
    },
  },
};
</script>

<style scoped lang="scss">
.item-descr-list .item-descr-tit {
  vertical-align: middle;
}
.width-400 {
  width: 400px;
}
.custom-select-template {
  background-color: #1c1c1c;
  ::v-deep .tc-15-dropdown-link {
    text-align: left;
  }
}
</style>
